import forOwn from 'mout/object/forOwn'

/**
 * 
 * @param {string} subject The subject name of the subtest
 * @param {object} userAssessment The userAssessment or GroupUA
 * @returns {object} The assessmentSubtest with the displayName you specified
 */
export default function getSubtest(subject, userAssessment) {
  let subtest
  forOwn(userAssessment.assessmentSubtests, (sub, key) => {
    if (sub.displayName === subject) {
      subtest = sub
    }
  })
  return subtest
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getSubtest.js